<template>
  <div class="policy-form-page">
    <!-- 基础配置 -->
    <el-card shadow="never" class="form-card">
      <div slot="header" class="card-header">
        <i class="el-icon-setting card-header__icon" />
        <span class="card-header__text">基础配置</span>
      </div>
      <el-form label-width="100px" label-position="right" class="base-form">
        <el-form-item label="策略名称" required>
          <el-input v-model="strategyinput" placeholder="请输入策略名称" clearable class="form-input--medium" />
        </el-form-item>
        <el-form-item label="策略平台" required>
          <el-select
            v-model="mstrategy"
            filterable
            placeholder="请选择策略平台"
            :disabled="ontype == 0"
            class="form-input--medium"
            @change="strategyplatform"
          >
            <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id" />
          </el-select>
          <span class="form-tip form-tip--danger">涉及到 AB 号跳转，请选择通用平台</span>
        </el-form-item>
        <el-form-item v-if="mstrategy != null" label="标签组" required>
          <el-select
            v-model="labelgroupid"
            multiple
            :disabled="optionsr.length === 0"
            placeholder="请选择标签组"
            class="form-input--wide"
            @visible-change="biaoqianzu"
          >
            <el-option v-for="item in optionsr" :key="item.id" :label="item.tag_group_name" :value="item.id" />
          </el-select>
          <span class="form-tip">多标签组合为并且的关系</span>
        </el-form-item>
        <el-form-item label="关注时间">
          <div class="inline-field-group">
            <el-select v-model="subscribe_time_type" placeholder="请选择" class="form-input--medium">
              <el-option v-for="item in optionsrr" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
            <el-date-picker
              v-if="subscribe_time_type === 7"
              v-model="subscribetime"
              class="form-input--daterange"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm"
              :default-time="['00:00:00', '23:59:59']"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :clearable="false"
              @change="timechanger"
            />
          </div>
        </el-form-item>
        <el-form-item label="互动时间">
          <div class="inline-field-group">
            <el-select v-model="interaction_time_type" placeholder="请选择" class="form-input--medium">
              <el-option v-for="item in optionsrr" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
            <el-date-picker
              v-if="interaction_time_type === 7"
              v-model="interactiontime"
              class="form-input--daterange"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm"
              :default-time="['00:00:00', '23:59:59']"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :clearable="false"
              @change="timechangerall"
            />
          </div>
        </el-form-item>
        <el-form-item label="付费情况">
          <el-radio-group v-model="consumption">
            <el-radio :label="0">全部</el-radio>
            <el-radio :label="1">未付费</el-radio>
            <el-radio :label="2">已付费</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="策略类型" required>
          <el-radio-group v-model="strategytype" :disabled="ontype == 0">
            <el-radio v-for="(item, index) in strategytypearr" :key="index" :label="item.key">{{ item.value }}</el-radio>
          </el-radio-group>
          <span class="form-tip form-tip--danger">编辑时不可修改策略类型</span>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 延时策略 -->
    <el-card v-show="strategytype === 1" shadow="never" class="form-card">
      <div slot="header" class="card-header">
        <i class="el-icon-time card-header__icon" />
        <span class="card-header__text">延时策略</span>
        <el-tag size="mini" type="info" class="card-header__tag">{{ delayedarr.length }} 条</el-tag>
      </div>
      <div ref="delayCardScroll" class="card-scroll">
        <div v-for="(item, index) in delayedarr" :key="index" class="strategy-item">
          <div class="strategy-item__header">
            <span class="strategy-item__index">第 {{ index + 1 }} 条</span>
            <div class="strategy-item__actions">
              <el-button type="primary" size="mini" plain icon="el-icon-document-copy" @click="copyone(item)">复制</el-button>
              <el-button v-if="index !== 0" type="danger" size="mini" plain icon="el-icon-delete" @click="delectr(index)">删除</el-button>
            </div>
          </div>
          <div class="strategy-item__body">
            <el-form label-width="100px" label-position="right" class="strategy-form">
              <el-form-item label="延时时间">
                <div class="time-input-group">
                  <div class="time-input-item">
                    <el-select v-model="item.hour" filterable placeholder="时" class="time-input-select">
                      <el-option v-for="items in houroptionsr" :key="items.value" :label="items.label" :value="items.value" />
                    </el-select>
                    <span class="time-input-suffix">时</span>
                  </div>
                  <div class="time-input-item">
                    <el-select v-model="item.minutes" filterable placeholder="分" class="time-input-select">
                      <el-option v-for="items in minutesoptions" :key="items.value" :label="items.label" :value="items.value" />
                    </el-select>
                    <span class="time-input-suffix">分</span>
                  </div>
                  <div class="time-input-item">
                    <el-select v-model="item.seconds" filterable placeholder="秒" class="time-input-select">
                      <el-option v-for="items in secondoptions" :key="items.value" :label="items.label" :value="items.value" />
                    </el-select>
                    <span class="time-input-suffix">秒</span>
                  </div>
                </div>
              </el-form-item>
              <el-form-item label="延迟动作">
                <el-select v-model="item.delayTypes" filterable placeholder="请选择延迟动作" class="form-input--medium" @change="sb($event, index)">
                  <el-option v-for="items in delaytypearr" :key="items.key" :label="items.value" :value="items.key" />
                </el-select>
              </el-form-item>
              <el-form-item v-if="item.delayTypes === 2" label="关键字">
                <el-input v-model.trim="item.delayKeywords" placeholder="请输入关键字" clearable class="form-input--medium" />
              </el-form-item>
              <el-form-item v-if="mstrategy != null" label="选择消息">
                <div class="message-select">
                  <span class="message-select__text" :class="{ 'is-empty': !item.relationmessage }">
                    {{ item.relationmessage || '暂未选择消息' }}
                  </span>
                  <el-button size="mini" type="primary" plain @click="choose(item, index)">
                    {{ item.relationmessage ? '修改消息' : '选择消息' }}
                  </el-button>
                  <el-button v-if="item.relationmessage && item.relationType != 3" size="mini" plain @click="timingpreview(item)">预览</el-button>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </el-card>

    <!-- 关键词策略 -->
    <el-card v-show="strategytype === 2" shadow="never" class="form-card">
      <div slot="header" class="card-header">
        <i class="el-icon-chat-line-square card-header__icon" />
        <span class="card-header__text">关键词策略</span>
        <el-tag size="mini" type="info" class="card-header__tag">{{ keywordsarr.length }} 条</el-tag>
      </div>
      <div v-for="(item, index) in keywordsarr" :key="index" class="strategy-item">
        <div class="strategy-item__header">
          <span class="strategy-item__index">第 {{ index + 1 }} 条</span>
          <div class="strategy-item__actions">
            <el-button type="primary" size="mini" plain icon="el-icon-document-copy" @click="copytwo(item)">复制</el-button>
            <el-button v-if="index !== 0" type="danger" size="mini" plain icon="el-icon-delete" @click="keywordsarr.splice(index, 1)">删除</el-button>
          </div>
        </div>
        <div class="strategy-item__body">
          <el-form label-width="100px" label-position="right" class="strategy-form">
            <el-form-item label="关键词">
              <el-input v-model.trim="item.keyword" placeholder="请输入关键词" clearable class="form-input--medium" />
              <span class="form-tip form-tip--danger">填写 "*" 表示任意关键字都会回复此消息，其它关键字不生效</span>
            </el-form-item>
            <el-form-item v-if="mstrategy != null" label="选择消息">
              <div class="message-select">
                <span class="message-select__text" :class="{ 'is-empty': !item.relationmessage }">
                  {{ item.relationmessage || '暂未选择消息' }}
                </span>
                <el-button size="mini" type="primary" plain @click="chooseone(item, index)">
                  {{ item.relationmessage ? '修改消息' : '选择消息' }}
                </el-button>
                <el-button v-if="item.relationmessage && item.relationType != 3" size="mini" plain @click="timingpreview(item)">预览</el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-card>

    <!-- 定时推送策略 -->
    <el-card v-show="strategytype === 3" shadow="never" class="form-card">
      <div slot="header" class="card-header">
        <i class="el-icon-alarm-clock card-header__icon" />
        <span class="card-header__text">定时推送策略</span>
        <el-tag size="mini" type="info" class="card-header__tag">{{ timedpusharr.length }} 条</el-tag>
      </div>
      <div v-for="(item, index) in timedpusharr" :key="index" class="strategy-item">
        <div class="strategy-item__header">
          <span class="strategy-item__index">第 {{ index + 1 }} 条</span>
          <div class="strategy-item__actions">
            <el-button type="primary" size="mini" plain icon="el-icon-document-copy" @click="copythree(item)">复制</el-button>
            <el-button v-if="index !== 0" type="danger" size="mini" plain icon="el-icon-delete" @click="timedpusharr.splice(index, 1)">删除</el-button>
          </div>
        </div>
        <div class="strategy-item__body">
          <el-form label-width="100px" label-position="right" class="strategy-form">
            <el-form-item label="执行周期">
              <div class="inline-field-group">
                <el-select v-model="item.cyclevalue" placeholder="请选择周期" class="form-input--medium" @change="implement(item)">
                  <el-option v-for="itemr in cycle" :key="itemr.value" :label="itemr.label" :value="itemr.value" />
                </el-select>
                <el-select v-if="item.cyclevalue == 2" v-model="item.weekvalue" placeholder="请选择星期" class="form-input--small">
                  <el-option v-for="itemr in weekarr" :key="itemr.value" :label="itemr.label" :value="itemr.value" />
                </el-select>
                <div v-if="item.cyclevalue == 3" class="time-input-item">
                  <el-input v-model="item.dayvalue" type="number" class="time-input-select time-input-select--day" @blur="dayewr(index)" />
                  <span class="time-input-suffix">日</span>
                </div>
                <div class="time-input-item">
                  <el-select v-model="item.hourvalue" filterable placeholder="时" class="time-input-select">
                    <el-option v-for="items in houroptions" :key="items.value" :label="items.label" :value="items.value" />
                  </el-select>
                  <span class="time-input-suffix">时</span>
                </div>
                <div class="time-input-item">
                  <el-select v-model="item.minutevalue" filterable placeholder="分" class="time-input-select">
                    <el-option v-for="items in minutesoptions" :key="items.value" :label="items.label" :value="items.value" />
                  </el-select>
                  <span class="time-input-suffix">分</span>
                </div>
              </div>
            </el-form-item>
            <el-form-item v-if="mstrategy != null" label="选择消息">
              <div class="message-select">
                <span class="message-select__text" :class="{ 'is-empty': !item.relationmessage }">
                  {{ item.relationmessage || '暂未选择消息' }}
                </span>
                <el-button size="mini" type="primary" plain @click="choosethree(item, index)">
                  {{ item.relationmessage ? '修改消息' : '选择消息' }}
                </el-button>
                <el-button v-if="item.relationmessage && item.relationType != 3" size="mini" plain @click="timingpreview(item)">预览</el-button>
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <timingtable v-if="this.$route.query.type === 0" :id="ids" />
    </el-card>

    <!-- 底部操作 -->
    <el-card shadow="never" class="form-card form-card--actions">
      <div class="form-actions">
        <el-button @click="goback">返回</el-button>
        <el-button type="primary" :loading="savedisabled" @click="saveclick">保存</el-button>
      </div>
    </el-card>

    <!-- 预览标签组弹窗 -->
    <el-dialog title="预览" :visible.sync="dialogVisible" :modal-append-to-body="false" :append-to-body="true" width="720px">
      <Labelgroupdialog ref="labeldialog" :optionsr="optionsr" />
    </el-dialog>
    <!-- 选择消息弹窗 -->
    <el-dialog title="选择消息" :visible.sync="dialogVisiblemessage" :modal-append-to-body="false" :append-to-body="true" :destroy-on-close="true" width="800px">
      <Timingtemp ref="sub" :oneselectarr="oneselectarr" :twoselectarr="twoselectarr" :selectoptionse="selectoptions" @gione="gione" />
    </el-dialog>
    <!-- 预览选中效果弹窗 -->
    <el-dialog title="预览" :visible.sync="priwdialogVisible" :modal-append-to-body="false" :append-to-body="true" width="720px">
      <PreviewDialog ref="timepreview" />
    </el-dialog>
  </div>
</template>

<script>
import { strategyList, actionHelper, strategyPlatform, customercreatlist, customermessagelist, addstrategy, adminlist, templateadminlist, servicelook, administratorslook, strategyinfo, strategyEdit } from '@/api/sourceMaterial.js'
import Labelgroupdialog from '../customerServicelist/components/Labelgroupdialog.vue'
import Timingtemp from './components/Timingtemp.vue'
import timingtable from './components/timingtable.vue'
import PreviewDialog from '../timedPush/components/PreviewDialog.vue'
import convertToHump from '@/utils/mixins/convertToHump.js'
export default {
  components: {
    Labelgroupdialog,
    Timingtemp,
    PreviewDialog,
    timingtable
  },
  mixins: [convertToHump],
  data() {
    return {
      interaction_time_type: 0, // 关注时间类型
      interactiontime: [], // 关注时间 自定义 数组
      interaction_time_from: '', // 关注时间开始时间
      interaction_time_to: '', // 关注时间结束时间
      subscribetime: [], // 互动时间 自定义数组
      subscribe_time_from: '', // 互动时间 开始时间
      subscribe_time_to: '', // 互动时间 结束时间
      subscribe_time_type: 0, // 互动时间类型
      consumption: 0, // 付费情况
      optionsrr: [{ // 关注时间 互动时间 数组
        value: 0,
        label: '不限'
      }, {
        value: 8,
        label: '24小时内'
      }, {
        value: 1,
        label: '2天(48小时)以内'
      }, {
        value: 2,
        label: '2天(48小时)前'
      }, {
        value: 3,
        label: '2至7天'
      }, {
        value: 4,
        label: '7天内'
      }, {
        value: 5,
        label: '7天前'
      }, {
        value: 6,
        label: '今天前'
      },
      {
        value: 7,
        label: '自定义'
      }],
      strategyinput: null, // 策略名称
      mstrategy: null, // 策略平台
      labelgroupid: [], // 标签组id
      options: [], // 策略平台数组
      optionsr: [], // 选择标签组数组

      dialogVisible: false, // 预览标签组弹窗
      dialogVisiblemessage: false, // 选择消息弹窗
      priwdialogVisible: false,
      strategytype: 1, // 策略类型 绑定值
      strategytypearr: [], // 策略类型
      delaytypearr: [], // 延迟动作数组

      delayedarr: [{
        delayTypes: null, // 延迟类型
        // durations: null, // 时间
        hour: 0, // 时
        minutes: 0, // 分
        seconds: 0, // 秒
        relationType: null, // 消息类型
        relationId: null, // 消息选择id
        relationmessage: null,
        delayKeywords: ''
      }], // 延时策略复制的数组

      keywordsarr: [{
        keyword: null,
        relationType: null, // 消息类型
        relationId: null, // 消息选择id
        relationmessage: null
      }],

      timedpusharr: [{
        time: new Date(2022, 6, 1, 18, 40),
        relationType: null, // 消息类型
        relationId: null, // 消息选择id
        relationmessage: null,

        cyclevalue: null,
        hourvalue: '', // 每小时
        minutevalue: '', // 每分钟

        weekvalue: null, // 星期几

        dayvalue: null // 填日期
      }],
      // 关键词
      obj: {
        page: 1,
        pageSize: 10,
        title: null,
        msgType: null,
        customerMessageNo: null
      },

      cycle: [
        {
          value: 1,
          label: '每天'
        }, {
          value: 2,
          label: '每星期'
        }, {
          value: 3,
          label: '每月'
        }
      ],
      weekarr: [
        {
          value: 1,
          label: '周一'
        }, {
          value: 2,
          label: '周二'
        }, {
          value: 3,
          label: '周三'
        }, {
          value: 4,
          label: '周四'
        }, {
          value: 5,
          label: '周五'
        }, {
          value: 6,
          label: '周六'
        }, {
          value: 7,
          label: '周日'
        }
      ],

      oneselectarr: {},
      twoselectarr: {},
      selectoptions: [], // 筛选类数组

      suo: null,

      ids: null, // 策略编号
      messageload: false,
      savedisabled: false,
      houroptions: [], // 小时数组
      houroptionsr: [],
      minutesoptions: [], // 分钟数组
      secondoptions: [], // 秒钟数组
      storagetype: null,
      ontype: null
    }
  },
  beforeDestroy() {
    if (this.storagetype === 9) {
      console.log('进来了')
      if (!this.messageload) {
        const data = {
          strategyinput: this.strategyinput,
          mstrategy: this.mstrategy,
          labelgroupid: this.labelgroupid,
          subscribe_time_type: this.subscribe_time_type,
          subscribetime: this.subscribetime,
          interaction_time_type: this.interaction_time_type,
          interactiontime: this.interactiontime,
          consumption: this.consumption,
          strategytype: this.strategytype,
          delayedarr: this.delayedarr,
          timedpusharr: this.timedpusharr,
          delaytypearr: this.delaytypearr,
          keywordsarr: this.keywordsarr

        }
        window.localStorage.setItem('newPolicyMassageStorage', JSON.stringify(data))
      } else {
        window.localStorage.removeItem('newPolicyMassageStorage')
      }
    }
  },
  created() {
    // eslint-disable-next-line eqeqeq
    console.log('this.$route:', this.$route.meta.type)

    window.aa = this
    // 初始化时分秒
    this.inittimearr(0, 24, this.houroptions)
    this.inittimearr(0, 48, this.houroptionsr)
    this.inittimearr(0, 59, this.minutesoptions)
    this.inittimearr(0, 59, this.secondoptions)
    if (JSON.stringify(this.$route.query) !== '{}') {
      this.ontype = this.$route.query.type
      strategyinfo({ strategy_no: JSON.parse(this.$route.query.item) }).then((res) => {
        this.consumption = res.data.strategy.user_wheres == null ? 0 : res.data.strategy.user_wheres.consumption
        if (res.data.strategy.user_wheres == null) {
          this.interaction_time_type = 0
        } else {
          if (res.data.strategy.user_wheres.interaction_time) {
            this.interaction_time_type = res.data.strategy.user_wheres.interaction_time.type
            if (res.data.strategy.user_wheres.interaction_time.interaction_time_range.length !== 0) {
              this.interaction_time_from = res.data.strategy.user_wheres.interaction_time.interaction_time_range[0]
              this.interaction_time_to = res.data.strategy.user_wheres.interaction_time.interaction_time_range[1]
              this.interactiontime = res.data.strategy.user_wheres.interaction_time.interaction_time_range
            }
          } else {
            this.interaction_time_type = 0
          }
        }
        if (res.data.strategy.user_wheres == null) {
          this.subscribe_time_type = 0
        } else {
          if (res.data.strategy.user_wheres.subscribe_time) {
            this.subscribe_time_type = res.data.strategy.user_wheres.subscribe_time.type
            if (res.data.strategy.user_wheres.subscribe_time.subscribe_time_range.length !== 0) {
              this.subscribe_time_from = res.data.strategy.user_wheres.subscribe_time.subscribe_time_range[0]
              this.subscribe_time_to = res.data.strategy.user_wheres.subscribe_time.subscribe_time_range[1]
              this.subscribetime = res.data.strategy.user_wheres.subscribe_time.subscribe_time_range
            }
          } else {
            this.subscribe_time_type = 0
          }
        }

        // res.data = this.convertToHump(res.data)
        this.strategyinput = res.data.strategy.strategy_name
        this.strategytype = res.data.strategy.strategy_type
        this.mstrategy = res.data.strategy.platform_id
        this.ids = res.data.strategy.strategy_no
        adminlist({
          page: 1,
          page_size: 50,
          platform_id: res.data.strategy.platform_id
        }).then((res) => {
          this.optionsr = []
          this.optionsr = res.data.list
          this.optionsr.unshift({
            id: 0,
            tag_group_name: '全部'
          })
        })

        // eslint-disable-next-line eqeqeq
        if (res.data.strategy.tag_group_ids.length == 0) {
          this.labelgroupid = [0]
        } else {
          this.labelgroupid = res.data.strategy.tag_group_ids
        }

        if (res.data.strategy.strategy_type === 1) {
          this.delayedarr = []
          res.data.msg_data.forEach((items, index) => {
            const vote = {}
            vote.relationId = items.relation_id
            vote.relationType = items.relation_type
            vote.relationmessage = items.message_name + '(' + items.relation_id + ')'
            this.delayedarr.push(vote)
          })
          res.data.strategy_data.delay_keywords.forEach((items, index) => {
            this.$set(this.delayedarr[index], 'delayKeywords', items)
            // this.delayedarr[index].delayKeywords = items
          })
          res.data.strategy_data.delay_types.forEach((items, index) => {
            this.$set(this.delayedarr[index], 'delayTypes', items)
            // this.delayedarr[index].delayTypes = items
          })
          res.data.strategy_data.durations.forEach((items, index) => {
            // this.$set(this.delayedarr[index], 'durations', items)
            this.$set(this.delayedarr[index], 'hour', items.hour)
            this.$set(this.delayedarr[index], 'minutes', items.minutes)
            this.$set(this.delayedarr[index], 'seconds', items.seconds)
            // this.delayedarr[index].durations = items
          })
        }

        if (res.data.strategy.strategy_type === 2) {
          this.keywordsarr = []
          res.data.msg_data.forEach((items, index) => {
            const vote = {}
            vote.relationId = items.relation_id
            vote.relationType = items.relation_type
            vote.relationmessage = items.message_name + '(' + items.relation_id + ')'
            this.keywordsarr.push(vote)
          })
          res.data.strategy_data.keywords.forEach((items, index) => {
            this.$set(this.keywordsarr[index], 'keyword', items)
            // this.keywordsarr[index].keyword = items
          })
        }
        if (res.data.strategy.strategy_type === 3) {
          this.timedpusharr = []
          res.data.msg_data.forEach((items, index) => {
            const vote = {}
            vote.relationId = items.relation_id
            vote.relationType = items.relation_type
            vote.relationmessage = items.message_name + '(' + items.relation_id + ')'
            vote.cyclevalue = items.cycle_type
            vote.hourvalue = items.hour
            vote.minutevalue = items.minute
            vote.weekvalue = items.day_of_week
            vote.dayvalue = items.day_of_month

            //          cyclevalue: null,
            // hourvalue: '', // 每小时
            // minutevalue: '', // 每分钟

            // weekvalue: null, // 星期几

            // dayvalue: null // 填日期
            this.timedpusharr.push(vote)
          })
          // res.data.strategyData.timeHi.forEach((items, index) => {
          //   this.$set(this.timedpusharr[index], 'time', new Date(2022, 6, 2, items.slice(0, 2), items.slice(2)))
          //   console.log('2222', items.slice(2))
          //   console.log('3333', items.slice(0, 2))
          // })
        }
      })
    } else {
      this.ontype = 3
      this.storagetype = 9
      const res = window.JSON.parse(window.localStorage.getItem('newPolicyMassageStorage') || '{}')
      if (Object.keys(res).length !== 0) {
        this.strategyinput = res.strategyinput
        this.mstrategy = res.mstrategy
        this.labelgroupid = res.labelgroupid
        this.subscribe_time_type = res.subscribe_time_type
        this.subscribetime = res.subscribetime
        this.interaction_time_type = res.interaction_time_type
        this.interactiontime = res.interactiontime
        this.consumption = res.consumption
        this.strategytype = res.strategytype
        this.delayedarr = res.delayedarr
        this.timedpusharr = res.timedpusharr
        this.delaytypearr = res.delaytypearr
        this.keywordsarr = res.keywordsarr
      }
    }
    this.getstrategyplatform()
    this.getstrategyList()
    this.getdelayType()
    // this.menuList()
    // this.gettemplatelist()
    this.typelist()
    this.optionsr.push({
      id: 0,
      tag_group_name: '全部'
    })
  },
  mounted() {

  },
  methods: {
    timechanger(val) {
      this.subscribe_time_from = val[0]
      this.subscribe_time_to = val[1]
      console.log('val', val)
    },
    timechangerall(val) {
      this.interaction_time_from = val[0]
      this.interaction_time_to = val[1]
      console.log('val', val)
    },
    // 初始化时分秒
    inittimearr(valone, valtwo, arr) {
      for (let i = valone; i <= valtwo; i++) {
        arr.push({
          value: i,
          label: `${i}`
        })
      }
    },
    // 获取客服消息
    menuList() {
      customercreatlist(this.obj).then(res => {
        this.oneselectarr = res.data
      })
    },
    // 获取模板消息 接口
    async gettemplatelist() {
      const data = await templateadminlist({
        page: 1,
        pageSize: 10
      })
      this.twoselectarr = this.convertToHump(data.data)
    },
    // 获取筛选类数组
    async typelist() {
      const data = await customermessagelist()
      this.selectoptions = data.data.list
    },
    // 获取策略平台
    async getstrategyplatform() {
      const data = await strategyPlatform()
      this.options = data.data.list
      console.log('获取策略平台', data)
    },
    // 获取策略类型
    async getstrategyList() {
      const data = await strategyList()
      this.strategytypearr = data.data
      console.log('策略类型', data)
    },
    // 获取延迟动作 接口
    async getdelayType() {
      const data = await actionHelper()
      this.delaytypearr = data.data
      console.log('延迟动作', data)
    },
    // 策略平台变化 请求标签组 接口
    async strategyplatform(val) {
      const data = await adminlist({
        page: 1,
        page_size: 50,
        platform_id: val
      })
      this.optionsr = []
      this.optionsr = data.data.list
      // if (this.labelgroupid !== 0) {
      //   this.labelgroupid = null
      // }

      this.optionsr.unshift({
        id: 0,
        tag_group_name: '全部'
      })
      this.labelgroupid = []
      // eslint-disable-next-line eqeqeq
      if (this.strategytype == 1) {
        console.log('类型1', this.delayedarr)
        this.delayedarr.forEach((item) => {
          this.$set(item, 'relationType', null)
          this.$set(item, 'relationId', null)
          this.$set(item, 'relationmessage', null)
        })
        // eslint-disable-next-line eqeqeq
      } else if (this.strategytype == 2) {
        console.log('类型2')
        // keywordsarr
        this.keywordsarr.forEach((item) => {
          this.$set(item, 'relationType', null)
          this.$set(item, 'relationId', null)
          this.$set(item, 'relationmessage', null)
        })
      } else {
        console.log('类型3')
        this.timedpusharr.forEach((item) => {
          this.$set(item, 'relationType', null)
          this.$set(item, 'relationId', null)
          this.$set(item, 'relationmessage', null)
        })
      }
      console.log('data', data)
    },
    // 预览标签组
    labelpreview() {
      this.dialogVisible = true
      console.log('this.labelgroupid', this.labelgroupid)
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.labeldialog.labelsend(this.labelgroupid)
      }, 100)
    },
    // 复制
    copyone(item) {
      console.log(item)
      this.delayedarr.push({
        delayTypes: item.delayTypes, // 延迟类型
        // durations: item.durations, // 时间
        hour: item.hour, // 时
        minutes: item.minutes, // 分
        seconds: item.seconds, // 秒
        relationType: item.relationType, // 消息类型
        relationId: item.relationId, // 消息选择id
        relationmessage: item.relationmessage,
        delayKeywords: item.delayKeywords
      })
      this.$nextTick(() => {
        const el = this.$refs.delayCardScroll
        if (el) {
          el.scrollTop = el.scrollHeight
        }
      })
    },
    copytwo(item) {
      //       keyword: null,
      // relationType: null, // 消息类型
      // relationId: null, // 消息选择id
      // relationmessage: null
      this.keywordsarr.push({
        keyword: item.keyword, // 延迟类型
        relationType: item.relationType, // 消息类型
        relationId: item.relationId, // 消息选择id
        relationmessage: item.relationmessage
      })
    },
    copythree(item) {
      this.timedpusharr.push({
        time: item.time, // 延迟类型
        relationType: item.relationType, // 消息类型
        relationId: item.relationId, // 消息选择id
        relationmessage: item.relationmessage,

        cyclevalue: item.cyclevalue,
        hourvalue: item.hourvalue, // 每小时
        minutevalue: item.minutevalue, // 每分钟

        weekvalue: item.weekvalue, // 星期几

        dayvalue: item.dayvalue // 填日期
      })
    },
    choose(item, index) {
      if (this.mstrategy === null) {
        this.$message.error('请选择平台')
        return
      }
      this.dialogVisiblemessage = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.sub.send(item, index, this.mstrategy)
      }, 100)
    },
    chooseone(item, index) {
      if (this.mstrategy === null) {
        this.$message.error('请选择平台')
        return
      }
      this.dialogVisiblemessage = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.sub.send(item, index, this.mstrategy)
      }, 100)
    },
    choosethree(item, index) {
      if (this.mstrategy === null) {
        this.$message.error('请选择平台')
        return
      }
      this.dialogVisiblemessage = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.sub.send(item, index, this.mstrategy)
      }, 100)
    },
    gione(type, id, name, index) {
      // if
      if (this.strategytype === 1) {
        console.log('进来1')
        //       delayedarr: [{
        //   delayTypes: null, // 延迟类型
        //   durations: null, // 时间
        //   relationType: null, // 消息类型
        //   relationId: null, // 消息选择id
        //   relationmessage: null
        // }], // 延时策略复制的数组
        console.log(type, id, name, index)
        this.delayedarr[index].relationmessage = name + '(' + id + ')'
        this.delayedarr[index].relationId = id
        this.delayedarr[index].relationType = type.messytie

        this.dialogVisiblemessage = false
      }

      if (this.strategytype === 2) {
        console.log('进来2')
        // keywordsarr: [{
        //   keyword: null,
        //   relationType: null, // 消息类型
        //   relationId: null, // 消息选择id
        //   relationmessage: null
        // }],
        console.log(type, id, name, index)
        this.keywordsarr[index].relationmessage = name + '(' + id + ')'
        this.keywordsarr[index].relationId = id
        this.keywordsarr[index].relationType = type.messytie

        this.dialogVisiblemessage = false
      }
      if (this.strategytype === 3) {
        console.log('进来3')
        // keywordsarr: [{
        //   keyword: null,
        //   relationType: null, // 消息类型
        //   relationId: null, // 消息选择id
        //   relationmessage: null
        // }],
        console.log(type, id, name, index)
        this.timedpusharr[index].relationmessage = name + '(' + id + ')'
        this.timedpusharr[index].relationId = id
        this.timedpusharr[index].relationType = type.messytie

        this.dialogVisiblemessage = false
      }
    },
    // 保存
    saveclick() {
      if (this.strategyinput === null) {
        this.$message.error('请填写策略名称')
        return
      }
      if (this.mstrategy === null) {
        this.$message.error('请选择策略平台')
        return
      }
      if (this.labelgroupid.length === 0) {
        this.$message.error('请选择标签组')
        return
      }
      console.log(this.strategyinput, '策略名称')
      console.log(this.mstrategy, '策略平台：')
      console.log(this.labelgroupid, '标签组id')
      console.log(this.strategytype, '策略组类型')
      // if(this.strategyinput === null)
      if (this.strategytype === 1) {
        console.log('this.delayedarr', this.delayedarr)
        const arr = []
        const obj = {}
        obj.delay_types = []
        obj.durations = []
        obj.delay_keywords = []
        this.delayedarr.forEach((item) => {
          arr.push({
            relation_type: item.relationType,
            relation_id: item.relationId
          })
          obj.delay_types.push(
            item.delayTypes
          )
          // obj.durations.push(
          //   item.durations
          // )
          obj.durations.push({
            hour: item.hour,
            minutes: item.minutes,
            seconds: item.seconds
          })
          obj.delay_keywords.push(
            item.delayKeywords
          )
        })
        const bool = this.delayedarr.every((item, index, array) => {
          return item.hour !== null
        })
        if (bool === false) {
          this.$message.error('请填写延时小时')
          return
        }
        const booltwo = this.delayedarr.every((item, index, array) => {
          return item.minutes !== null
        })
        if (booltwo === false) {
          this.$message.error('请填写延时分钟')
          return
        }
        const boolthree = this.delayedarr.every((item, index, array) => {
          return item.seconds !== null
        })
        if (boolthree === false) {
          this.$message.error('请填写延时秒数')
          return
        }
        // const bools = this.delayedarr.every((item, index, array) => {
        //   return item.durations !== ''
        // })
        // if (bools === false) {
        //   this.$message.error('请填写延时时间')
        //   return
        // }

        const timebool = this.delayedarr.every((item, index, array) => {
          return item.delayTypes !== null
        })
        if (timebool === false) {
          this.$message.error('请选择延迟动作')
          return
        }

        const relationbool = this.delayedarr.every((item, index, array) => {
          return item.relationId !== null
        })
        if (relationbool === false) {
          this.$message.error('请选择消息')
          return
        }
        this.delayedarr.forEach((item) => {
          if (item.delayTypes === 2) {
            if (item.delayKeywords === '') {
              this.$message.error('请输入关键词')
              this.suo = 1
            } else {
              this.suo = null
            }
          }
        })

        console.log('arr', arr, obj, this.delayedarr)
        if (this.suo !== 1) {
          this.setaxios(this.strategyinput, this.mstrategy, this.labelgroupid, this.strategytype, arr, obj)
        }
      }
      if (this.strategytype === 2) {
        const arr = []
        const obj = {}
        obj.keywords = []
        this.keywordsarr.forEach((item) => {
          arr.push({
            relation_type: item.relationType,
            relation_id: item.relationId
          })
          obj.keywords.push(
            item.keyword
          )
        })
        const bool = this.keywordsarr.every((item, index, array) => {
          return item.keyword !== null
        })
        if (bool === false) {
          this.$message.error('请填写关键词回复')
          return
        }
        const bools = this.keywordsarr.every((item, index, array) => {
          return item.keyword !== ''
        })
        if (bools === false) {
          this.$message.error('请填写关键词回复')
          return
        }
        console.log(this.keywordsarr, arr, obj)
        this.setaxios(this.strategyinput, this.mstrategy, this.labelgroupid, this.strategytype, arr, obj)
      }
      if (this.strategytype === 3) {
        const arr = []
        const obj = {}
        obj.time_hi = []
        this.timedpusharr.forEach((item) => {
        // hourvalue: item.hourvalue, // 每小时
        // minutevalue: item.minutevalue, // 每分钟
          arr.push({
            relation_type: item.relationType,
            relation_id: item.relationId,
            cycle_type: item.cyclevalue,
            day_of_month: item.dayvalue,
            day_of_week: item.weekvalue,
            hour: item.hourvalue,
            minute: item.minutevalue
          })
          // obj.time_hi.push(
          //   item.time
          // )
        })
        obj.time_hi.forEach((item, index) => {
          obj.time_hi[index] = this.settime(item)
        })
        const implementbool = this.timedpusharr.every((item, index, array) => {
          return item.cyclevalue !== null
        })
        if (implementbool === false) {
          this.$message.error('请选择执行周期')
          return
        }

        const weekvaluebool = this.timedpusharr.some((item, index, array) => {
          return item.weekvalue === null && item.cyclevalue === 2
        })
        if (weekvaluebool === true) {
          this.$message.error('请选择执行的星期数')
          return
        }
        const dayvaluebool = this.timedpusharr.some((item, index, array) => {
          return item.dayvalue === null && item.cyclevalue === 3 || item.dayvalue === '' && item.cyclevalue === 3
        })
        if (dayvaluebool === true) {
          this.$message.error('请填写执行周期日期')
          return
        }
        const hourbool = this.timedpusharr.every((item, index, array) => {
          return item.hourvalue !== ''
        })
        if (hourbool === false) {
          this.$message.error('请填写小时')
          return
        }
        const minutebool = this.timedpusharr.every((item, index, array) => {
          return item.minutevalue !== ''
        })
        if (minutebool === false) {
          this.$message.error('请填写分钟')
          return
        }
        const relationbool = this.timedpusharr.every((item, index, array) => {
          return item.relationId !== null
        })
        if (relationbool === false) {
          this.$message.error('请选择消息')
          return
        }
        if (this.subscribe_time_type === null) {
          this.$message.error('请选择关注时间')
          return
        }
        if (this.interaction_time_type === null) {
          this.$message.error('请选择互动时间')
          return
        }
        if (this.subscribe_time_type === 7) {
          if (this.subscribetime.length === 0) {
            this.$message.error('请选择自定义时间范围')
            return
          }
        }
        if (this.interaction_time_type === 7) {
          if (this.interactiontime.length === 0) {
            this.$message.error('请选择自定义时间范围')
            return
          }
        }
        this.setaxios(this.strategyinput, this.mstrategy, this.labelgroupid, this.strategytype, arr, obj) // 以前传obj 现在改为传{}
        console.log('2222', this.timedpusharr, arr, obj.time_hi)
      }

      // this.timedpusharr.forEach((item) => {
      //   console.log('67666', item.time, this.settime(item.time))
      //   // item.time = this.settime(item.time)
      // })
      console.log('timedpusharr', this.timedpusharr)
      this.messageload = true
    },
    setaxios(strategyinput, mstrategy, labelgroupid, strategytype, arr, obj) {
      this.savedisabled = true
      const parms = {}
      if (this.subscribe_time_type === 7) {
        parms.subscribe_time_type = this.subscribe_time_type
        parms.subscribe_time_from = this.subscribe_time_from
        parms.subscribe_time_to = this.subscribe_time_to
        parms.consumption = this.consumption
      } else {
        parms.subscribe_time_type = this.subscribe_time_type
        parms.consumption = this.consumption
      }
      const huparms = {}
      if (this.interaction_time_type === 7) {
        huparms.interaction_time_type = this.interaction_time_type
        huparms.interaction_time_from = this.interaction_time_from
        huparms.interaction_time_to = this.interaction_time_to
      } else {
        huparms.interaction_time_type = this.interaction_time_type
      }
      // eslint-disable-next-line eqeqeq
      if (this.ontype == 0) {
        console.log('编辑', this.ids)
        this.$confirm('您确定变更了内容需要保存吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          closeOnClickModal: false,
          type: 'warning'
        }).then(() => {
          strategyEdit({
            platform_id: mstrategy,
            strategy_type: strategytype,
            strategy_name: strategyinput,
            msg_data: arr,
            strategy_data: obj,
            tag_group_ids: labelgroupid,
            strategy_no: this.ids,
            ...parms,
            ...huparms
          }).then(res => {
            if (res.code === 200) {
              this.$message({
                message: '提交成功',
                type: 'success'
              })
              this.suo = null
              this.$router.push({ path: '/customerServicelist/index' })
              this.savedisabled = false
            }
          }).catch(err => {
            console.log(err)
            this.savedisabled = false
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
          this.savedisabled = false
        })
      } else {
        addstrategy({
          platform_id: mstrategy,
          strategy_type: strategytype,
          strategy_name: strategyinput,
          msg_data: arr,
          strategy_data: obj,
          tag_group_ids: labelgroupid,
          ...parms,
          ...huparms
        }).then(res => {
          if (res.code === 200) {
            this.$message({
              message: '提交成功',
              type: 'success'
            })
            this.suo = null
            this.$router.push({ path: '/customerServicelist/index' })
            this.savedisabled = false
          }
        }).catch(err => {
          console.log(err)
          this.savedisabled = false
        })
      }
    },
    settime(value1) {
      const d = new Date(value1)
      let _h = d.getHours() + ''
      if (_h.length === 1) {
        _h = '0' + _h
      }
      let _m = d.getMinutes() + ''
      if (_m.length === 1) {
        _m = '0' + _m
      }
      return _h + _m
      // return value1.getHours().toString().padStart(2, '0') + value1.getMinutes().toString().padStart(2, '0')
    },
    timingpreview(item) {
      console.log(item, '=========')
      if (item.relationType === 1) {
        console.log('客服')
        servicelook({
          message_no: item.relationId
        }).then((res) => {
          this.priwdialogVisible = true
          setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
            this.$refs.timepreview.send(res.data.info, 1)
          }, 100)
        })
      }
      if (item.relationType === 2) {
        administratorslook({
          template_message_admin_no: item.relationId
        }).then((res) => {
          console.log('res模板', res)
          this.priwdialogVisible = true
          setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
            this.$refs.timepreview.send(res.data.info, 2)
          }, 100)
        })
        console.log('模板')
      }
    },
    sb(val, index) {
      console.log(val, index)
      // this.$set(this.delayedarr[index], 'this.delayedarr[index].delayTypes', val)
      if (val === 1) {
        this.delayedarr[index].delay_keywords = ''
      }
      this.delayedarr[index].delay_types = val
      this.$forceUpdate()
    },
    goback() {
      this.$router.go(-1)
    },
    delectr(index) {
      this.delayedarr.splice(index, 1)
    },
    implement(item) {
      // weekvalue: null, // 星期几
      // dayvalue: '' // 填日期
      if (item.cyclevalue === 1) {
        item.weekvalue = null
        item.dayvalue = null
      } else if (item.cyclevalue === 2) {
        item.dayvalue = null
      } else {
        item.weekvalue = null
      }

      console.log('item', item)
    },
    tinebulie(index) {
      console.log('index', index)
      // eslint-disable-next-line eqeqeq
      if (this.timedpusharr[index].hourvalue < 0 && this.timedpusharr[index].hourvalue != '') {
        this.timedpusharr[index].hourvalue = 0
      }
      // 判断不能输入小数点
      const str = '' + this.timedpusharr[index].hourvalue
      if (str.indexOf('.') !== -1) {
        console.log('小鼠了')
        this.timedpusharr[index].hourvalue = 0
      }
      if (this.timedpusharr[index].hourvalue > 23) {
        this.timedpusharr[index].hourvalue = 23
      }
    },
    tiwrrw(index) {
      // eslint-disable-next-line eqeqeq
      if (this.timedpusharr[index].minutevalue < 0 && this.timedpusharr[index].minutevalue != '') {
        this.timedpusharr[index].minutevalue = 0
      }
      // 判断不能输入小数点
      const str = '' + this.timedpusharr[index].minutevalue
      if (str.indexOf('.') !== -1) {
        console.log('小鼠了')
        this.timedpusharr[index].minutevalue = 0
      }
      if (this.timedpusharr[index].minutevalue > 59) {
        this.timedpusharr[index].minutevalue = 59
      }
    },
    dayewr(index) {
      // eslint-disable-next-line eqeqeq
      if (this.timedpusharr[index].dayvalue < 1 && this.timedpusharr[index].dayvalue != '') {
        this.timedpusharr[index].dayvalue = 1
      }
      // 判断不能输入小数点
      const str = '' + this.timedpusharr[index].dayvalue
      if (str.indexOf('.') !== -1) {
        console.log('小鼠了')
        this.timedpusharr[index].dayvalue = 0
      }
      if (this.timedpusharr[index].dayvalue > 31) {
        this.timedpusharr[index].dayvalue = 31
      }
    },
    biaoqianzu() {
      console.log('this.labelgroupid', this.labelgroupid)
      for (let i = 0; i < this.labelgroupid.length; i++) {
        if (this.labelgroupid[i] === 0) {
          this.labelgroupid = [0]
        }
      }
    }
    // timew(val, index) {
    //   // console.log('val', val, index)

    //   this.timedpusharr[index].time = val
    //   //  this.$set(this.timedpusharr[index], 'time', val)
    //   this.$forceUpdate()
    // }
  }
}
</script>
<style scoped>
.policy-form-page {
  min-height: calc(100vh - 84px);
  padding: 20px 24px 80px;
  background: #f0f2f5;
  box-sizing: border-box;
}

/* 卡片 */
.form-card {
  margin-bottom: 16px;
  border-radius: 8px;
  border: 1px solid #ebeef5;
}

.form-card ::v-deep .el-card__header {
  padding: 14px 20px;
  background: #fafbfc;
  border-bottom: 1px solid #ebeef5;
}

.form-card ::v-deep .el-card__body {
  padding: 24px 20px 8px;
}

.card-header {
  display: flex;
  align-items: center;
}

.card-header__icon {
  margin-right: 8px;
  font-size: 16px;
  color: #3a71a8;
}

.card-header__text {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}

.card-header__tag {
  margin-left: 10px;
}

/* 表单 */
.base-form,
.strategy-form {
  max-width: 960px;
}

.form-input--wide {
  width: 100%;
  max-width: 560px;
}

.form-input--medium {
  width: 240px;
}

.form-input--small {
  width: 130px;
}

.form-input--daterange {
  width: 400px;
}

.form-tip {
  display: block;
  margin-top: 6px;
  font-size: 12px;
  color: #909399;
  line-height: 1.5;
}

.form-tip--danger {
  color: #f56c6c;
}

.inline-field-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

/* 策略条目 */
.strategy-item {
  margin-bottom: 16px;
  background: #fafbfc;
  border: 1px solid #ebeef5;
  border-radius: 8px;
  overflow: hidden;
  transition: box-shadow 0.2s;
}

.strategy-item:last-child {
  margin-bottom: 8px;
}

.strategy-item:hover {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.strategy-item__header {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: #fff;
  border-bottom: 1px solid #ebeef5;
}

.strategy-item__index {
  font-size: 14px;
  font-weight: 600;
  color: #3a71a8;
}

.strategy-item__actions {
  display: flex;
  gap: 8px;
  margin-left: 546px;
}

.strategy-item__body {
  padding: 16px 16px 4px;
}

/* 时间输入组 */
.time-input-group,
.inline-field-group .time-input-item {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}

.time-input-item {
  display: flex;
  align-items: stretch;
}

.time-input-select {
  width: 90px;
}

.time-input-select--day {
  width: 80px;
}

.time-input-select ::v-deep .el-input__inner {
  border-radius: 4px 0 0 4px;
}

.time-input-suffix {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  padding: 0 8px;
  font-size: 13px;
  color: #606266;
  background: #f5f7fa;
  border: 1px solid #dcdfe6;
  border-left: none;
  border-radius: 0 4px 4px 0;
  box-sizing: border-box;
}

/* 消息选择 */
.message-select {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.message-select__text {
  flex: 1;
  min-width: 200px;
  max-width: 480px;
  padding: 8px 12px;
  font-size: 13px;
  color: #303133;
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  line-height: 1.5;
  word-break: break-all;
}

.message-select__text.is-empty {
  color: #c0c4cc;
}

/* 底部操作 */
.form-card--actions {
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 9;
  width: calc(100% - 210px);
  margin-bottom: 0;
  border-radius: 0;
  border-left: none;
  border-right: none;
  border-bottom: none;
  box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
  transition: width 0.28s;
}

.form-card--actions ::v-deep .el-card__body {
  padding: 16px 20px;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
}

/* 隐藏 number 输入框箭头 */
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

::v-deep input[type='number'] {
  -moz-appearance: textfield !important;
  appearance: textfield;
}

@media (max-width: 768px) {
  .policy-form-page {
    padding: 16px 16px 80px;
  }

  .base-form,
  .strategy-form {
    max-width: 100%;
  }

  .form-input--wide,
  .form-input--medium,
  .form-input--small,
  .form-input--daterange {
    width: 100% !important;
    max-width: 100%;
  }

  .strategy-item__header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .strategy-item__actions {
    width: 100%;
  }

  .message-select__text {
    max-width: 100%;
  }
}
.card-scroll {
  overflow-y: auto;
  max-height: 500px;
}
</style>

<style lang="scss">
#app .hideSidebar .policy-form-page .form-card--actions {
  width: calc(100% - 54px);
}

#app .mobile .policy-form-page .form-card--actions {
  width: 100%;
}
</style>
